import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { DEFAULT_CONFIG } from '../constants/index';

@Injectable()
export class AtxNotificationService {
    constructor(private readonly nzService: NzNotificationService) {}

    public success(title: string, content: string, config = DEFAULT_CONFIG) {
        this.setConfig(config);

        this.nzService.success(title, content);
    }

    public error(title: string, content: string, config = DEFAULT_CONFIG) {
        this.setConfig(config);

        this.nzService.error(title, content);
    }

    public warning(title: string, content: string, config = DEFAULT_CONFIG) {
        this.setConfig(config);

        this.nzService.warning(title, content);
    }

    public info(title: string, content: string, config = DEFAULT_CONFIG) {
        this.setConfig(config);

        this.nzService.info(title, content);
    }

    public blank(title: string, content: string, config = DEFAULT_CONFIG) {
        this.setConfig(config);

        this.nzService.blank(title, content);
    }

    private setConfig(config) {
        config = { ...DEFAULT_CONFIG, ...config };

        this.nzService.config({
            nzAnimate: config.animate,
            nzDuration: config.duration,
            nzPlacement: config.placement,
        });
    }
}
